import React from "react";
import AutomotiveBanner from "../../../Assets/Product_Images/AutomotiveGlass/AutomotiveBanner.jpg";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import Automotive_Glass1 from "../../../Assets/Product_Images/AutomotiveGlass/image16.webp";
import Automotive_Glass2 from "../../../Assets/Product_Images/AutomotiveGlass/image19.webp";
import Automotive_Glass3 from "../../../Assets/Product_Images/AutomotiveGlass/image2.webp";
import { Link } from "react-router-dom";

const Aluminum_windows = () => {
  return (
    <div>
      <Header />
      {/* banner section start  */}
      <section
        className="container-fluid common_banner"
        style={{
          backgroundImage: `url(${AutomotiveBanner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="common_title wow fadeInUp">
                <h2>
                  <Link
                    to="/AboutUs"
                    className="text-decoration-none text-white"
                  >
                    ABOUT US
                  </Link>
                  / <span className="text-white">Automotive Glass</span>
                </h2>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* banner section end */}

      {/* about tabbing section start */}
      <section className="container-fluid about_Products_section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="blog_text wow fadeInUp">
                <h5 style={{ color: "#153fa4", fontFamily: "Segoe UI, sans-serif", fontSize: "40px", fontWeight: "700", marginBottom: "15px" }}>Automotive Glass</h5>
                <p>
                  We are a trusted manufacturer of a wide range of **Automotive
                  Toughened Glass** solutions designed to offer enhanced safety,
                  durability, and aesthetic appeal. Our glass products are
                  engineered using modern techniques and high-quality materials,
                  meeting the demands of the automotive industry with precision
                  and reliability.
                </p>

                <p>
                  <strong>Automotive Glass:</strong> Our automotive glass is
                  manufactured using premium-grade inputs and advanced
                  production technology. Known for its high strength, crack
                  resistance, and long-lasting performance, it is ideal for
                  various vehicle types. Each piece undergoes stringent quality
                  checks in accordance with industry standards to ensure maximum
                  safety and clarity. Available at competitive pricing, it's a
                  cost-effective choice for OEMs and service providers.
                </p>

                <p>
                  <strong>Digitally Printed Automotive Glass:</strong> Designed
                  for those who want to add a touch of customization and style,
                  our digitally printed automotive glass combines aesthetics
                  with strength. Using advanced digital printing techniques, we
                  create seamless designs directly on the glass surface without
                  compromising structural integrity. It's perfect for branding,
                  personalization, and unique vehicle styling—delivered with
                  crack resistance and a smooth finish.
                </p>
              </div>
              <div className="Products_img gap-5 mt-5 wow fadeInUp">
                <img src={Automotive_Glass1} style={{width : "250px" , height : "250px"}} alt="Bus" />
                <img src={Automotive_Glass2} style={{width : "250px" , height : "250px"}} alt="car" />
                <img src={Automotive_Glass3} style={{width : "250px" , height : "250px"}} alt="car" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* about tabbing section End  */}

      <Footer />
    </div>
  );
};

export default Aluminum_windows;
